// extracted by mini-css-extract-plugin
export default {"modalOverlay":"CC-z","modalContent":"DC-z","header":"EC-z","close":"FC-z"};